const phonePrefix = {
  prefix: {
    label: "Prefix",
  },
};

export default phonePrefix;
